import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  CONTACT_EMAIL,
  CONTACT_NAME,
  INTERNAL_LIAISON,
  INTERNAL_LIAISON_EMAIL,
  MEDIA_ORGANISATION_NAME,
  RELEVANCE_TO_COMPANY,
  REPRESENTATION_CATEGORY,
} from 'constants/formFields';
import { DEFAULT_OPTION, OPTION_CATEGORY_NOGS } from 'constants/general';
import getValueOption from 'utils/getOptionValue';
import { mediaCreateSchema } from 'utils/validators';

import type { TMediaCreateSchema } from 'utils/validators';
import type ICreateMediaForm from '../interfaces/ICreateMedialForm';

const useCreateMediaForm = ({ isPageLoading, selectedItem }: ICreateMediaForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TMediaCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(mediaCreateSchema),
    defaultValues: {
      [MEDIA_ORGANISATION_NAME]: '',
      [REPRESENTATION_CATEGORY]: DEFAULT_OPTION,
      [CONTACT_NAME]: '',
      [CONTACT_EMAIL]: '',
      [RELEVANCE_TO_COMPANY]: '',
      [INTERNAL_LIAISON]: '',
      [INTERNAL_LIAISON_EMAIL]: '',
    },
  });

  useEffect(() => {
    if (selectedItem) {
      setValue(MEDIA_ORGANISATION_NAME, selectedItem.name);
      setValue(REPRESENTATION_CATEGORY, getValueOption(OPTION_CATEGORY_NOGS, selectedItem.representationCategory));
      setValue(CONTACT_NAME, selectedItem.contactName);
      setValue(CONTACT_EMAIL, selectedItem.contactEmail);
      setValue(RELEVANCE_TO_COMPANY, selectedItem.relevance);
      setValue(INTERNAL_LIAISON, selectedItem.internalLiaison);
      setValue(INTERNAL_LIAISON_EMAIL, selectedItem.internalLiaisonEmail);
    }
  }, [selectedItem, setValue]);

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateMediaForm;
